export default __webpack_public_path__ + "static/media/t-shirt.d8fd36ec.svg";